<script setup lang="ts">
import EpIcon from '~/components/icon/EpIcon.vue'
import ShareModal from '~/components/modal/ShareModal.vue'

interface IProps {
  to: string
  label: string
}

defineProps<IProps>()

const showShareModal = ref(false)

const setShowShareModal = (value: boolean) => {
  showShareModal.value = value
}
</script>

<template>
  <div class="flex items-center justify-between px-4 py-2">
    <NuxtLink
      :to="to"
      class="flex items-center gap-x-2"
    >
      <EpIcon
        name="chevron_left"
        :size="20"
        class="p-2 text-primary"
      />
      <span>{{ label }}</span>
    </NuxtLink>
    <div
      class="relative"
      id="share-button-wrapper"
    >
      <button
        class="flex items-center justify-center p-2 text-primary"
        @click="setShowShareModal(true)"
      >
        <EpIcon
          name="share"
          :size="20"
        />
      </button>
    </div>
  </div>
  <ClientOnly>
    <Teleport to="#share-button-wrapper">
      <ShareModal
        v-if="showShareModal"
        @update:show-share-modal="setShowShareModal"
      />
    </Teleport>
  </ClientOnly>
</template>

<style scoped lang="scss">

</style>